
export class AssetDTO {
    url: string = '';
}


export class typeDTO {
    mainLogo:AssetDTO = new AssetDTO();
    darkLogo:AssetDTO = new AssetDTO();
    lightLogo:AssetDTO = new AssetDTO();
  }
  
  export class typeDetails {
    flatData:typeDTO = new  typeDTO();
  }

  export class  speakersDto {
  
    name:string = '';
    type:typeDetails = new typeDetails();
    value:string = '';
    isURL:string = '';
  }

  export class lecturersDetails{
    lecturername:string = '';
    lecturertitle:string= '';
    lecturercover:AssetDTO = new AssetDTO();
  }
  export class lecturersDto{
    flatData:lecturersDetails = new lecturersDetails();
  }